import React from 'react';
import { IconProps } from '@/models/IconProps';

const Download: React.FC<IconProps> = ({ strokeColor = 'currentColor', height = '24', width = '24' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.75 3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V11.1893L10.5303 10.4697C10.2374 10.1768 9.76256 10.1768 9.46967 10.4697C9.17678 10.7626 9.17678 11.2374 9.46967 11.5303L11.4697 13.5303C11.7626 13.8232 12.2374 13.8232 12.5303 13.5303L14.5303 11.5303C14.8232 11.2374 14.8232 10.7626 14.5303 10.4697C14.2374 10.1768 13.7626 10.1768 13.4697 10.4697L12.75 11.1893V3Z"
      fill={strokeColor}
    />
    <path
      d="M3.75 15C3.75 13.7574 4.75736 12.75 6 12.75C6.41421 12.75 6.75 12.4142 6.75 12C6.75 11.5858 6.41421 11.25 6 11.25C3.92893 11.25 2.25 12.9289 2.25 15V17C2.25 19.6234 4.37665 21.75 7 21.75H17C19.6234 21.75 21.75 19.6234 21.75 17V15C21.75 12.9289 20.0711 11.25 18 11.25C17.5858 11.25 17.25 11.5858 17.25 12C17.25 12.4142 17.5858 12.75 18 12.75C19.2426 12.75 20.25 13.7574 20.25 15V17C20.25 18.7949 18.7949 20.25 17 20.25H7C5.20507 20.25 3.75 18.7949 3.75 17V15Z"
      fill={strokeColor}
    />
  </svg>
);

export default Download;
